/**
 * デジタルサイネージ登録用ダイアログモジュール。
 * @module app/signage/SignageRegisterDialog
 */
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/text!./templates/SignageRegisterDialog.html',
    'dojo/topic',
    'app/signage/_SignageDialogBase',
    'app/signage/DisplayType',
    // 以下、変数で受けないモジュール
    'idis/view/form/RadioGroup',
    'idis/view/form/WordCountTextarea',
    'idis/view/form/WordCountTextBox',
    'app/view/form/MunicipalitySelector',
    'app/view/form/OrganizationSelector',
    'app/view/form/DisasterSelector',
    'app/view/form/EarthQuakeSelector',
    'app/signage/damagetype/DamageTypeSelector',
    'app/view/form/CustomizableMunicipalitySelector'
], function(module, declare, lang, template, topic, _SignageDialogBase, DisplayType) {

    return declare(module.id.replace(/\//g, '.'), _SignageDialogBase,
    {
        // テンプレート文字列
        templateString: template,

        constructor: function() {
            this.inherited(arguments);
        },

        buildRendering: function() {
            this.inherited(arguments);
        },
    
        /**
         * ダイアログを初期化する。
         */
        initDialog: function() {
            this.reset();
            this.initForm();
            this.initSearchSelector(this.displayType.value);

            this.own(topic.subscribe(this.DAMAGE_TYPE_SELECTED, lang.hitch(this, function (data) {
                this.setDamageType(data);
            })));

            this.own(topic.subscribe(this.DAMAGE_TYPE_RELEASED, lang.hitch(this, function (data) {
                this.releaseDamageType(data);
            })));
        },

        /**
         * フォームを初期化する。
         */
        initForm: function () {
            // ディスプレイ種別にモデルをセット
            this.displayType.set('store', DisplayType);
            // 日付のセレクトボックスを生成する
            this.setDateSelect();
            // 時間のセレクトボックスを生成する
            this.setTimeSelect();
            // 被害の種類を初期化
            this.innerDamageTypeSelector.release();
        },
        

        /**
         * 登録する。
         */
        onSubmit: function() {
            try {
                // フォームのバリデーションを実施
                if (!this.form.validate()) {
                    return false;
                }
                // 固有のバリデーションを実施
                if (!this.validate()) {
                    return false;
                }
                var value = this.form.get('value');
                value.damageTypeList = this._damageTypeList;
                this.emit('register', { value: value });
            } catch (e) {
                console.error(e);
            }
            return false;
        }

    });
});
